<template>
    <NuxtImg :src="finalSrc" :alt="alt" :width="width" :height="height" placeholder :provider="provider"
        @error="handleError" v-if="!error" />
    <img :src="finalSrc" :alt="alt" v-else />
</template>

<script setup>
const props = defineProps({
    src: String,
    alt: String,
    width: Number,
    height: Number
})
const error = ref(false)
const provider = ref("")
const finalSrc = ref("")

const createImageSrc = () => {
    if (!props.src || props.src === "undefined") {
        provider.value = "s3"
        return '/assets/blog/thumbnails/pathway-card.png'
    }
    if (props.src.startsWith('http')) {
        finalSrc.value = props.src
        return props.src
    }
    provider.value = "s3"
    return props.src
}

const handleError = () => {
    provider.value = false
    finalSrc.value = finalSrc.value.replace('/assets/blog/', '/assets/content/blog/')
    error.value = true
}

watch(() => props.src, (newSrc) => {
    finalSrc.value = createImageSrc()
    error.value = false
}, { immediate: true })
</script>
